module.exports = __webpack_public_path__ + "9d9e969bc5b7f7ecd9f8e05da278fd01.svg";